import { makeActionCreator } from '../../config/store/utils'
import { getSmallerCompaniesCompared } from '../../services/smallerCompanies'
import { SECTORS_COLORS, COMPANIES_COLORS } from '../../config/settings/constants'

export const GET_SMALLER_COMPANIES_COMPARED = 'GET_SMALLER_COMPANIES_COMPARED'
export const GET_SMALLER_COMPANIES_COMPARED_ERROR = 'GET_SMALLER_COMPANIES_COMPARED_ERROR'
export const GET_SMALLER_COMPANIES_COMPARED_SUCCESS = 'GET_SMALLER_COMPANIES_COMPARED_SUCCESS'

export const onGetSmallerCompaniesCompared = makeActionCreator(GET_SMALLER_COMPANIES_COMPARED)
export const onGetSmallerCompaniesComparedError = makeActionCreator(GET_SMALLER_COMPANIES_COMPARED_ERROR, 'payload')
export const onGetSmallerCompaniesComparedSuccess = makeActionCreator(GET_SMALLER_COMPANIES_COMPARED_SUCCESS, 'payload')

export const onGetSmallerCompaniesComparedThunk =
  ({ sector }) =>
  async dispatch => {
    dispatch(onGetSmallerCompaniesCompared())

    try {
      const response = await getSmallerCompaniesCompared({ sector })

      const data = response.data.payload

      const enhancedData = data.map(item => ({
        year: item.anio,
        sector: SECTORS_COLORS.find(sector => sector.value === parseInt(item.idSector))?.name,
        idSector: item.idSector,
        amountMicro: item.montoMicro,
        amountUSDMicro: item.montoUSDMicro,
        amountSmaller: item.montoPequenia,
        amountUSDSmaller: item.montoUSDPequenia,
        amountMedium: item.montoMediana,
        amountUSDMedium: item.montoUSDMediana,
        amountCLPTotalEMT: item.montoCLPTotalEMT,
        amountUSDTotalEMT: item.montoUSDTotalEMT,
        amountCLPTotalCompanies: item.montoCLPTotalEmpresas,
        amountUSDTotalCompanies: item.montoUSDTotalEmpresas,
        percentageAmountTotalEMT: item.porcentajeMontoTotalEMT,
        ordersMicro: item.cantidadOrdenesMicro,
        ordersSmaller: item.cantidadOrdenesPequenia,
        ordersMediana: item.cantidadOrdenesMediana,
        ordersEMTTotal: item.cantidadEMTTotal,
        ordersTotal: item.cantidadTotal,
        percentageOCTotalEMT: item.porcentajeOCTotalEMT
      }))
      const CompaniesSeries = {
        name: COMPANIES_COLORS.find(d => d.value === 0).name,
        amount: enhancedData.map(d => d.amountCLPTotalCompanies),
        amountUSD: enhancedData.map(d => d.amountUSDTotalCompanies),
        orders: enhancedData.map(d => d.ordersTotal),
        color: COMPANIES_COLORS.find(d => d.value === 0).color
      }
      const EMTSeries = {
        name: COMPANIES_COLORS.find(d => d.value === 1).name,
        amount: enhancedData.map(d => d.amountCLPTotalEMT),
        amountUSD: enhancedData.map(d => d.amountUSDTotalEMT),
        orders: enhancedData.map(d => d.ordersEMTTotal),
        color: COMPANIES_COLORS.find(d => d.value === 1).color
      }

      const series = [CompaniesSeries, EMTSeries]
      const csv = [
        [
          'Año',
          'Sector del estado',
          'Micro Monto (CLP)',
          'Micro Monto(USD)',
          'Pequeña Monto (CLP)',
          'Pequeña Monto(USD)',
          'Mediana Monto (CLP)',
          'Mediana Monto(USD)',
          'Total EMT Monto (CLP)',
          'Total EMT Monto(USD)',
          'Total Empresas Monto (CLP)',
          'Total Empresas Monto(USD)',
          'Porcentaje Monto Total EMT',
          'Micro Cantidad de órdenes',
          'Pequeña Cantidad de órdenes',
          'Mediana Cantidad de órdenes',
          'Total EMT Cantidad de órdenes',
          'Total Empresas Cantidad de órdenes',
          'Porcentaje Órdenes Total EMT'
        ],
        ...enhancedData.map(d => [
          d.year,
          d.sector,
          d.amountMicro,
          d.amountUSDMicro,
          d.amountSmaller,
          d.amountUSDSmaller,
          d.amountMedium,
          d.amountUSDMedium,
          d.amountCLPTotalEMT,
          d.amountUSDTotalEMT,
          d.amountCLPTotalCompanies,
          d.amountUSDTotalCompanies,
          d.percentageAmountTotalEMT,
          d.ordersMicro,
          d.ordersSmaller,
          d.ordersMediana,
          d.ordersEMTTotal,
          d.ordersTotal,
          d.percentageOCTotalEMT
        ])
      ]

      dispatch(onGetSmallerCompaniesComparedSuccess({ data: enhancedData, series, csv }))
    } catch (error) {
      dispatch(onGetSmallerCompaniesComparedError({ error: 'Error al obtener datos', data: [], series: [], csv: [] }))
    }
  }
